import Layout from '../views/layout/layout'

export default {
    path: '/base',
    name: 'base',
    component: Layout,
    children: [
        {
            path: '/base/configComputeVariable/index',
            name: 'configComputeVariable',
            component: () => import('../views/base/configComputeVariable/index'),
            meta: {title: '项目经理收入变量配置'}
        },
        {
            path: '/base/projLabourConfig/index',
            name: 'projLabourConfigIndex',
            component: () => import('../views/base/projLabourConfig/index'),
            meta: {title: '人工费比例配置模板'}
        },
        {
            path: '/base/projManagerTpl/index',
            name: 'projManagerTpl',
            component: () => import('../views/base/projManagerTpl/index'),
            meta: {title: '项目经理收入模板'}
        },
        {
            path: '/base/projAssessmentTpl/index',
            name: 'projAssessmentTpl',
            component: () => import('../views/base/projAssessmentTpl/index'),
            meta: {title: '项目考核模板'}
        },
        {
            path: '/base/auxiliaryMaterialCheckConfig/index',
            name: 'MaterialCheckIndex',
            component: () => import('../views/base/auxiliaryMaterialCheckConfig/index'),
            meta: {title: '辅材验收配置'}
        },
        {
            path: '/base/projAssessmentTpl/detailItem',
            name: 'projAssessmentTplDetailItem',
            component: () => import('../views/base/projAssessmentTpl/detailItem'),
            meta: {title: '项目经理收入模板设置'}
        },
        {
            path: '/base/projManagerTpl/add',
            name: 'projManagerTplAdd',
            component: () => import('../views/base/projManagerTpl/add'),
            meta: {title: '新增/修改项目经理收入模板'}
        },
        {
            path: '/base/projManagerTpl/detail',
            name: 'projManagerTplDetail',
            component: () => import('../views/base/projManagerTpl/detail'),
            meta: {title: '设置模板字段'}
        },
        {
            path: '/base/projManagerTpl/detailItem',
            name: 'projManagerTplDetailItem',
            component: () => import('../views/base/projManagerTpl/detailItem'),
            meta: {title: '设置模板字段'}
        },
        {
            path: '/base/financePayment/index',
            name: 'projFinancePaymentTpl',
            component: () => import('../views/base/financePayment/index'),
            meta: {title: '收付款类型设置'}
        },
        {
            path: '/base/financePayment/relevance',
            name: 'projFinancePaymentRelevanceTpl',
            component: () => import('../views/base/financePayment/relevance'),
            meta: {title: '设置管理模板'}
        },
        {
            path: '/base/decoration/index',
            name: 'projDecorationTpl',
            component: () => import('../views/base/decoration/index'),
            meta: {title: '基装变更模板设置'}
        },
        {
            path: '/base/decoration/add',
            name: 'projDecorationTplAdd',
            component: () => import('../views/base/decoration/add'),
            meta: {title: '新增/修改基装变更模板'}
        },
        {
            path: '/base/projFnanceTpl/index',
            name: 'projFnanceTpl',
            component: () => import('../views/base/projFnanceTpl/index'),
            meta: {title: '预核算模板设置'}
        },
        {
            path: '/base/projFnanceTpl/add',
            name: 'projFnanceTplAdd',
            component: () => import('../views/base/projFnanceTpl/add'),
            meta: {title: '新增/修改预核算模板'}
        },

        {
            path: '/base/projPlanTplNew/add',
            name: 'projPlanTplNewAdd',
            component: () => import('../views/base/projPlanTplNew/add'),
            meta: {title: '新增/修改施工模板计划'}
        },
        {
            path: '/base/projPlanTplNew/index',
            name: 'projPlanTplNew',
            component: () => import('../views/base/projPlanTplNew/index'),
            meta: {title: '新施工模板计划'}
        },
        {
            path: '/base/projPlanTplNew/item',
            name: 'projPlanTplNewItem',
            component: () => import('../views/base/projPlanTplNew/item'),
            meta: {title: '新施工项信息设置'}
        },
        {
            path: '/base/projPlanTpl/index',
            name: 'projPlanTpl',
            component: () => import('../views/base/projPlanTpl/index'),
            meta: {title: '施工计划模板设置'}
        },
        {
            path: '/base/projPlanTpl/item',
            name: 'projPlanTplItem',
            component: () => import('../views/base/projPlanTpl/item'),
            meta: {title: '施工项信息设置'}
        },
        {
            path: '/base/u8Log/index',
            name: 'u8Log',
            component: () => import('../views/base/u8Log/index'),
            meta: {title: 'u8日志管理', keepAlive: true}
        },
        {
            path: '/base/log/operationLog/index',
            name: 'operationLog',
            component: () => import('../views/base/log/operationLog/index'),
            meta: {title: '系统操作日志管理', keepAlive: true}
        },
        {
            path: '/base/log/authOperationLog/index',
            name: 'authOperationLog',
            component: () => import('../views/base/log/authOperationLog/index'),
            meta: {title: '权限操作日志', keepAlive: true}
        },
        {
            path: '/base/projPlanTpl/material',
            name: 'projPlanTplMaterial',
            component: () => import('../views/base/projPlanTpl/material'),
            meta: {title: '材料计划模板设置'}
        },
        {
            path: '/base/projPlanTpl/add',
            name: 'projPlanTplAdd',
            component: () => import('../views/base/projPlanTpl/add'),
            meta: {title: '新增/修改施工模板计划'}
        },
        {
            path: '/base/cmdExportConfig/index',
            name: 'cmdExportConfigList',
            component: () => import('../views/base/cmdExportConfig/home/index'),
            meta: {title: 'Excel导出配置'}
        },
        {
            path: '/base/cmdImportConfig/index',
            name: 'cmdImportConfigList',
            component: () => import('../views/base/cmdImportConfig/home/index'),
            meta: {title: 'Excel导入配置'}
        },
        {
            path: '/base/cmdExportLog/index',
            name: 'cmdExportLogList',
            component: () => import('../views/base/cmdExportLog/index'),
            meta: {title: 'Excel导出查询'}
        },
        {
            path: '/base/cmdImportLog/index',
            name: 'cmdImportLogList',
            component: () => import('../views/base/cmdImportLog/index'),
            meta: {title: 'Excel导入查询'}
        },

        {
            path: '/base/menu/home',
            name: 'menuHome',
            component: () => import('../views/base/menu/menu_home'),
            meta: {title: '菜单管理', keepAlive: true}
        },
        {
            path: '/base/instrument/home',
            name: 'instrumentHome',
            component: () => import('../views/base/instrument/instrument_home'),
            meta: {title: '首页仪表盘', keepAlive: true}
        },
        {
            path: '/base/CategoryList',
            name: 'fwCategoryList',
            component: () => import('../views/base/fwCategory/fwCategory_home'),
            meta: {title: '字典类型管理', keepAlive: true}
        },
        {
            path: '/base/contractTaxRate',
            name: 'contractTaxRate',
            component: () => import('../views/base/contractTaxRate/index'),
            meta: {title: '税点管理', keepAlive: true}
        },
        {
            path: '/base/fwUser/home',
            name: 'fwUserHome',
            component: () => import('../views/base/fwUser/fwUser_home'),
            meta: {title: '自定义列维护', keepAlive: true}
        },
        {
            path: '/base/fwUser/column',
            name: 'fwUserColumn',
            component: () => import('../views/base/fwUser/fwUser_column'),
            meta: {title: '操作自定义内容'}
        },
        {
            path: '/base/msgLog/index',
            name: 'msgLog',
            component: () => import('../views/base/msgLog/index'),
            meta: {title: '短信日志管理', keepAlive: true}
        },
        {
            path: '/messageTemplate/index',
            name: 'cmdMessageTemplate',
            component: () => import('../views/base/cmdMessageTemplate/index'),
            meta: {title: '短信模板管理', keepAlive: true}
        },
        {
            path: '/database/configList',
            name: 'fwConfigList',
            component: () => import('../views/base/config/config_home'),
            meta: {title: '系统参数维护', keepAlive: true}
        },
        {
            path: '/fwrole/home',
            name: 'fwRoleList',
            component: () => import('../views/base/fwRole/fwRole_home'),
            meta: {title: '角色管理', keepAlive: true}
        },
        {
            path: '/fwAccount/home',
            name: 'fwAccountListHome',
            component: () => import('../views/base/fwAccount/fwAccount_home'),
            meta: {title: '账户管理', keepAlive: true}
        }, {
            path: '/fwCustomerService/home',
            name: 'fwCustomerList',
            component: () => import('../views/base/fwCustomerConfig/fwCustomer_home'),
            meta: {title: '客服配置', keepAlive: true}
        }, {
            path: '/atjiaImPromptStatement/home',
            name: 'ImPromptStatement',
            component: () => import('../views/atjia/imPromptStatement/index'),
            meta: {title: '客服提示语配置', keepAlive: true}
        },
        {
            path: '/fwAccount/change',
            name: 'fwAccountList',
            component: () => import('../views/base/fwAccount/changePsw'),
            meta: {title: '重置密码'}
        },
        {
            path: '/base/report/cmdReportServer/home',
            name: 'cmdReportServerHome',
            component: () => import('../views/base/report/server/index'),
            meta: {title: '报表服务器配置'}
        },
        {
            path: '/base/report/classifyCalculate',
            name: 'cmdReportServer',
            component: () => import('../views/base/report/classifyCalculate/index'),
            meta: {title: '订单是否参与计算维护'}
        },
        {
            path: '/base/report/cmdReportController/home',
            name: 'cmdReportController',
            component: () => import('../views/base/report/index'),
            meta: {title: '报表发布配置'}
        },
        {
            path: '/base/report/add',
            name: 'reportAdd',
            component: () => import('../views/base/report/add'),
            meta: {title: '新增报表配置'}
        },
        {
            path: '/base/report/update',
            name: 'reportUpdate',
            component: () => import('../views/base/report/update'),
            meta: {title: '修改报表配置'}
        },
        {
            path: '/base/reportSearch/index',
            name: 'reportSearchIndex',
            component: () => import('../views/base/reportSearch/index'),
            meta: {title: '报表搜索配置'}
        },
        {
            path: '/base/reportSearch/add',
            name: 'reportSearchAdd',
            component: () => import('../views/base/reportSearch/add'),
            meta: {title: '报表搜索配置新增'}
        },
        {
            path: '/base/reportSearch/update',
            name: 'reportSearchUpdate',
            component: () => import('../views/base/reportSearch/update'),
            meta: {title: '报表搜索配置修改'}
        },
        {
            path: '/station/home',
            name: 'fwStationList',
            component: () => import('../views/base/station/index'),
            meta: {title: '数据视野设置', keepAlive: true}
        },
        {
            path: '/channels/home',
            name: 'channelsList',
            component: () => import('../views/base/channels/index'),
            meta: {title: '渠道绑定维护', keepAlive: true}
        },
        {
            path: '/assessmentCategory/index',
            name: 'assessmentCategory',
            component: () => import('../views/base/assessmentCategory/index'),
            meta: {title: '参与主材考核的品类维护', keepAlive: true}
        },


        {
            path: '/supplementaryTerms/index',
            name: 'supplementaryTerms',
            component: () => import('../views/contract/supplementaryTerms/index'),
            meta: {title: '合同补充条款配置', keepAlive: true}
        },
        {
            path: '/help/index',
            name: 'fwHelpList',
            component: () => import('../views/base/help/help'),
            meta: {title: '帮助信息管理'}
        },
        {
            path: '/org/home',
            name: 'fwOrgList',
            component: () => import('../views/base/org/org_home'),
            meta: {title: '组织管理', keepAlive: true}
        },
        {
            path: '/fwOrgMaterialTarget/index',
            name: 'fwOrgMaterialTargetIndex',
            component: () => import('../views/base/fwOrgMaterialTarget/index'),
            meta: {title: '材料报表目标维护', keepAlive: true}
        },
        {
            path: '/fwOrgMaterialTarget/add',
            name: 'fwOrgMaterialTargetAdd',
            component: () => import('../views/base/fwOrgMaterialTarget/form/add'),
            meta: {title: '材料报表目标维护新增'}
        },
        {
            path: '/dataAuthority/dataEntity',
            name: 'dataEntityList',
            component: () => import('../views/base/dataAuthority/dataEntity/index'),
            meta: {title: '数据实体'}
        },
        {
            path: '/dataAuthority/dataSet',
            name: 'dataSetList',
            component: () => import('../views/base/dataAuthority/dataSet/index'),
            meta: {title: '业务模块数据设置'}
        },
        /// 定时任务配置页面
        {
            path: '/taskConfig/home',
            name: 'taskConfig',
            //redirect: '/dashboard',
            component: () => import('../views/base/task/taskConfig/index'),
            meta: {title: '任务配置'}
        },
        {
            path: '/taskEngine/home',
            name: 'taskEngine',
            component: () => import('../views/base/task/taskEngine/index'),
            meta: {title: '任务引擎'}
        },
        {
            path: '/taskHistory/home',
            name: 'taskHistory',
            component: () => import('../views/base/task/taskHistory/index'),
            meta: {title: '历史任务'}
        },
        /////// 工作流

        //流程方案
        {
            path: '/workFlow/define',
            name: 'defineFlow',
            component: () => import('../views/base/workFlow/define/index'),
            meta: {title: '流程定义'}
        },
        //流程定义
        {
            path: '/workFlow/program',
            name: 'programFlow',
            component: () => import('../views/base/workFlow/program/index'),
            meta: {title: '流程方案'}
        },
        // 部门管理
        {
            path: '/fwDepartment/home',
            name: 'departmentIndex',
            component: () => import('../views/department/index'),
            meta: {title: '部门管理', keepAlive: true}
        },
        // 队列错误消息管理
        {
            path: '/queueErrorMessage/home',
            name: 'queueErrorMessage',
            component: () => import('../views/queue/ErrorIndex'),
            meta: {title: '队列错误消息管理', keepAlive: true}
        },
        {
            path: '/queueConsumeMessage/home',
            name: 'queueConsumeMessage',
            component: () => import('../views/queue/ConsumeIndex'),
            meta: {title: '队列消费记录', keepAlive: true}
        },
        // 用户登录管理
        {
            path: '/fwAccountToken/index',
            name: 'fwAccountTokenIndex',
            component: () => import('../views/base/fwAccountToken/index'),
            meta: {title: '用户登录管理', keepAlive: true}
        },
        // 敏感信息
        {
            path: '/fwAccountAuthorization/index',
            name: 'fwAccountAuthorizationIndex',
            component: () => import('../views/base/fwAccountAuthorization/index'),
            meta: {title: '用户敏感信息报表', keepAlive: true}
        },
        // app弹窗图片配置
        {
            path: '/fwAppPhotoConfig/index',
            name: 'fwAppPhotoConfig/index',
            component: () => import('../views/base/fwAppPhotoConfig/index'),
            meta: {title: 'app弹窗图片配置', keepAlive: true}
        },
        //产品考核比例页面
        {
            path: '/prodAssessment/index',
            name: 'prodAssessment/index',
            component: () => import('../views/base/prodAssessment/index'),
            meta: {title: '产品考核比例', keepAlive: true}
        },

    ]
}
